export default "__VITE_ASSET__D0hEhuq2__"